// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#94A3B8","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#0F1C2E","menuHover":"rgba(59,130,246,0.12)","subMenuBg":"#0A1522","subMenuHover":"rgba(59,130,246,0.12)","sideBarWidth":"200px"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/styles/index.scss
// module id = LOPS
// module chunks = 8